// ============================================================
// หน้า UpdateRole — แก้ไขบทบาทผู้ใช้
// ------------------------------------------------------------
// เข้ามาพร้อม ?id=<role_id> แล้วโหลดสิทธิ์เดิมมาเติมลงตาราง
// ฟอร์ม/ตรรกะแปลงข้อมูลใช้ร่วมกับหน้าเพิ่มบทบาท
// ============================================================

import React, { Component } from "react";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import { tokens, success_url, GET, PUT, validate, loading, RoleForm, emptyRoleDetail, toApiRoleDetail, fromApiRoleDetail } from "../../shared/index.js";

export default class UpdateRole extends Component {
  state = { role_name: "", role_description: "", role_detail: emptyRoleDetail() };

  componentDidMount() {
    this.GetById(this.props.location.query.id);
  }

  GetById = async (id) => {
    loading(true);
    const result = await GET(tokens, `v1/TH/role-manage/detail/${id}`, null);
    if (result?.status) {
      const { role_name, role_description, role_detail } = result.data.data;
      this.setState({ role_name, role_description, role_detail: fromApiRoleDetail(role_detail) });
    }
    loading(false);
  };

  Update = async () => {
    if (validate(this.state, ["role_name"])) return;
    loading(true);

    const result = await PUT(tokens, "v1/TH/role-manage/update", {
      role_id: this.props.location.query.id,
      role_name: this.state.role_name,
      role_description: this.state.role_description,
      role_detail: toApiRoleDetail(this.state.role_detail),
    });
    if (result?.status) success_url("/role");

    loading(false);
  };

  render() {
    return (
      <div className="full bg-contain fade-in">
        <Navbar page1="หน้าหลัก" page2="ข้อมูลผู้ใช้" page3="บทบาทผู้ใช้" />
        <RoleForm
          title="แก้ไขบทบาทผู้ใช้"
          submitLabel="บันทึก"
          role_name={this.state.role_name}
          role_description={this.state.role_description}
          role_detail={this.state.role_detail}
          onChange={(patch) => this.setState(patch)}
          onSubmit={this.Update}
        />
      </div>
    );
  }
}
